import { render, staticRenderFns } from "./editMember.vue?vue&type=template&id=c56422ac&scoped=true&"
import script from "./editMember.vue?vue&type=script&lang=js&"
export * from "./editMember.vue?vue&type=script&lang=js&"
import style0 from "./editMember.vue?vue&type=style&index=0&id=c56422ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56422ac",
  null
  
)

export default component.exports